import type { MouseEvent } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ButtonBase, Tooltip, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";
import type { DrivingSchoolOtherEventCategory } from "../../providers/drivingSchoolOtherEventCategoriesProvider";

export function OtherEventCategoryMobileListItem(props: {
  category: DrivingSchoolOtherEventCategory;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { category, onClick } = props;
  const theme = useTheme();
  const paymentStatus =
    category.isPaid === null || category.isPaid === undefined
      ? undefined
      : category.isPaid
        ? "Bezahlt"
        : "Nicht bezahlt";
  const details = [paymentStatus, category.description].filter(Boolean).join(" • ");

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        height: "64px",
        overflow: "hidden",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Row gap={0.5} sx={{ minWidth: 0, width: "100%" }}>
          <Typography
            variant="body2"
            sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {category.name}
          </Typography>
          {category.isSystemCategory && (
            <Tooltip title="Nicht bearbeitbar">
              <LockOutlinedIcon fontSize="small" color="action" aria-label="Nicht bearbeitbar" />
            </Tooltip>
          )}
        </Row>
        {details && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {details}
          </Typography>
        )}
      </Column>
    </ButtonBase>
  );
}
